// src/components/CommentHistoryModal.js
import React, { useState, useEffect } from "react";
import "./CommentHistoryModal.css";
import { API_URL } from "../config";

const CommentHistoryModal = ({ orderId, commentId, isOpen, onClose }) => {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    fetch(
      `${API_URL}/orders/${orderId}/comments/${commentId}/history`,
      { credentials: "include" }
    )
      .then((res) => res.json())
      .then((data) => setHistory(data))
      .catch((err) => console.error("Błąd pobierania historii:", err));
  }, [isOpen, orderId, commentId]);

  if (!isOpen) return null;

  // Odwracamy historię, żeby Wersja 0 była najstarszą
  const sorted = [...history].reverse();

  return (
    <div className="modal-overlay">
      <div className="modal">
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
        <h2>Historia edycji komentarza</h2>

        {sorted.length > 0 ? (
          sorted.map((edit, idx) => (
            <div key={edit.edited_at} className="history-entry">
              <h3>Wersja {idx}</h3>
              <p className="history-text">{edit.comment_text}</p>
              <p className="history-meta">
                Edytowane przez: {edit.first_name} {edit.last_name}{" "}
                <br />
                Data: {new Date(edit.edited_at).toLocaleString("pl-PL")}
              </p>
            </div>
          ))
        ) : (
          <p>Brak zapisanej historii edycji.</p>
        )}
      </div>
    </div>
  );
};

export default CommentHistoryModal;
